import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';
import React from 'react';
import { ListBoxItem } from 'react-aria-components';

const ListBoxItemStyles = css(Object.assign(Object.assign({}, Typography.Body2), { margin: `var(--zds-space-8, 10px)`, padding: "var(--zds-space-6, 10px) var(--zds-space-8, 10px)", cursor: "pointer", '&[data-size="compact"], &[data-size="medium"]': {
  padding: `var(--zds-space-8, 8px)`
}, '&[data-size="compact"]': Object.assign({}, Typography.MinimalPrint2), "&[data-focus-visible]": {
  outline: "none",
  backgroundColor: `var(--zds-ui-primary-weakest, ${Colors.UiPrimaryWeakest})`,
  color: `var(--zds-ui-primary-strongest, ${Colors.UiPrimaryStrongest})`
}, "&[data-selected]": {
  fontWeight: 600,
  backgroundColor: `var(--zds-ui-primary-weakest, ${Colors.UiPrimaryWeakest})`,
  color: `var(--zds-ui-primary-strongest, ${Colors.UiPrimaryStrongest})`,
  "&::before": {
    position: "absolute",
    top: `var(--zds-space-4, 4px)`,
    left: `var(--zds-space-4, 4px)`
  }
}, "&[data-focused], &[data-pressed]": {
  backgroundColor: `var(--zds-ui-primary-weakest, ${Colors.UiPrimaryWeakest})`,
  color: `var(--zds-ui-primary-strongest, ${Colors.UiPrimaryStrongest})`
} }));
const TypeaheadItem = (_a) => {
  var { children, className, id, size = "large", textValue } = _a, props = __rest(_a, ["children", "className", "id", "size", "textValue"]);
  const childrenIsPureText = React.useMemo(() => React.Children.toArray(children).every((child) => typeof child === "string" || typeof child === "number"), [children]);
  if (!childrenIsPureText && !textValue) {
    console.error("Typeahead.Item: The `textValue` prop must be set if `children` is not plain text.");
  }
  return jsx(ListBoxItem, Object.assign({ className, css: ListBoxItemStyles, "data-size": size, "data-zds": true, id, textValue }, props), children);
};

export { TypeaheadItem };
//# sourceMappingURL=TypeaheadItem.es.js.map
